<section class="statList">
  <app-stats [user]="user"></app-stats>
</section>

<!-- <section
  *ngIf="user?.potentialSubscriptions && !isEmpty(user?.potentialSubscriptions)"
>
  <app-payment [product]="user.potentialSubscriptions"></app-payment>
</section> -->
